import {Point} from '../../@types/shared';

export default function (p1: Point, p2: Point): Point {
  return {
    x: p1.x - p2.x,
    y: p1.y - p2.y,
    z: p1.z === undefined ? undefined : p1.z - p2.z,
  };
}
